// extracted by mini-css-extract-plugin
export var buttons = "style-module--buttons--7ba0c";
export var modal = "style-module--modal--56dbc";